<template>
  <div>
    <p>Vuex Test</p>

    <h1>Notice</h1>
    <section>
      <dl>
        <dt>Vuex-Notice</dt>
        <dd>
          <span>{{ this.$store.getters["notice/notice"] || "empty vuex" }}</span>
        </dd>
      </dl>
      <dl>
        <dt>set</dt>
        <dd>
          <input v-model="noticeMessage" type="text" style="background: #fff; border: solid 1px" />
          <button @click="submit">Submit</button>
        </dd>
      </dl>
      <dl>
        <dt>delete</dt>
        <dd>
          <button @click="deleteNotice">delete</button>
        </dd>
      </dl>
    </section>
  </div>
</template>

<script>
export default {
  name: "Socket",
  data() {
    return {
      noticeMessage: null
    }
  },
  methods: {
    submit() {
      this.$store.dispatch("notice/setNotice", this.noticeMessage)
      this.noticeMessage = null
    },
    deleteNotice() {
      this.$store.dispatch("notice/setNotice", null)
    }
  },
  mounted: () => {
    // console.log(this.$store.getter["notice/"])
  }
}
</script>

<style scoped>
dl {
  border: solid 1px;
  padding: 16px;
}

dt {
  font-weight: bold;
}

dt:after {
  content: ":";
}

dd {
}

button {
  color: #fff;
  background: #8fbcbb;
  border: solid 1px #8fbcbb;
  border-radius: 4px;
  padding: 4px;
}
</style>
